export default "__VITE_ASSET__ChzCgrzB__"